<template>
    <div class="container-center">
        <el-tabs type="border-card" v-model="activeName" @tab-click="()=>{refresh(typeName)}">
            <el-tab-pane label="收件箱" name="inBox">
                <el-form inline :model="inBoxForm" label-width="90px" style="margin-bottom: 10px;">
                    <el-form-item label="消息主题：">
                        <el-input size="mini" v-model="inBoxForm.title" placeholder="模糊搜索"
                                  clearable></el-input>
                    </el-form-item>
                    <el-form-item label="消息类型：" v-if="typeName == '-1'">
                        <el-select clearable v-model="inBoxForm.messageType" placeholder="请选择消息类型" size="small" style="width:100%">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in messageTypeList" :key="item.value || item.id" :label="item.label || item.statusName" :value="item.value || item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-select clearable v-model="inBoxForm.readFlag" placeholder="请选择状态" size="small" style="width:100%">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in innerStatusList" :key="item.value || item.id" :label="item.label || item.statusName" :value="item.value || item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="default" size="mini" @click="resetInBoxForm">重 置</el-button>
                        <el-button type="primary" size="mini" @click="searchInBox">搜 索</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="inBoxes" border size="mini" highlight-current-row tooltip-effect="light" v-loading="inBoxTableLoading" style="width: 100%">
                    <el-table-column header-align="center"  align="center" type="index" width="50" label="序号">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" prop="title" label="信息主题" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column header-align="center" width="100px" align="center" prop="messageType" label="消息类型" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.messageType == 0">合同</span>
                            <span v-if="scope.row.messageType == 1">通知</span>
                            <span v-if="scope.row.messageType == 2">维修</span>
                            <span v-if="scope.row.messageType == 3">其他</span>
                        </template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" prop="createDate" label="接收时间" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column header-align="center" width="100px" align="center" prop="readFlagDes" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span :class="{ red: scope.row.readFlagDes == '未读' }">{{scope.row.readFlagDes}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="150px" >
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="scope.row.readFlag == '0'" @click="viewMsgHistory(scope.row)">查看</el-button>
                            <el-button type="text" size="mini" v-else-if="scope.row.readFlag != '-2'" @click="viewMsgHistory(scope.row)">查看消息历程</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    @current-change="(val) => { handleCurrentChange(val, 2) }"
                    prev-text="上一页"
                    next-text="下一页"
                    :current-page="inBoxForm.pageNum"
                    :page-size="inBoxForm.pageSize"
                    :total="inBoxForm.tableDataTotal">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="发件箱" name="sendBox">
                <el-form inline :model="sendBoxForm" label-width="90px" style="margin-bottom: 10px;">
                    <el-form-item label="消息主题：">
                        <el-input size="mini" v-model="sendBoxForm.title" placeholder="模糊搜索"
                                  clearable></el-input>
                    </el-form-item>
                    <el-form-item label="消息类型：" v-if="typeName == '-1'">
                        <el-select clearable v-model="sendBoxForm.messageType" placeholder="请选择消息类型" size="small" style="width:100%">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in messageTypeList" :key="item.value || item.id" :label="item.label || item.statusName" :value="item.value || item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-select clearable v-model="sendBoxForm.readFlag" placeholder="请选择状态" size="small" style="width:100%">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in statusList" :key="item.value || item.id" :label="item.label || item.statusName" :value="item.value || item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="default" size="mini" @click="resetSendBoxForm" >重 置</el-button>
                        <el-button type="primary" size="mini" @click="searchSendBox">搜 索</el-button>
                        <el-button type="primary" size="mini" @click="addMsg">新增消息</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="sendBoxes" border style="width: 100%" size="mini" strip v-loading="sendBoxTableLoading">
                    <el-table-column header-align="center" align="center" type="index" width="50" label="序号">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" prop="title" label="信息主题" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column header-align="center" width="100px" align="center" prop="messageType" label="消息类型" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.messageType == 0">合同</span>
                            <span v-if="scope.row.messageType == 1">通知</span>
                            <span v-if="scope.row.messageType == 2">维修</span>
                            <span v-if="scope.row.messageType == 3">其他</span>
                        </template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" prop="createDate" label="创建/发送时间" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column header-align="center" width="100px" align="center" prop="readFlagDes" label="状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span :class="{ red: scope.row.readFlagDes == '未读' }">{{scope.row.readFlagDes}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="150px">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="scope.row.readFlag == '-2'" @click="edit(scope.row)">编辑</el-button>
                            <el-button type="text" size="mini" v-if="scope.row.readFlag == '-2'" @click="del(scope.row)">删除</el-button>
                            <el-button type="text" v-if="scope.row.readFlag == '0'" size="mini" @click="viewMsgHistory(scope.row)">查看</el-button>
                            <el-button type="text" v-else-if="scope.row.readFlag != '-2'" @click="viewMsgHistory(scope.row)" size="mini">查看消息历程</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    prev-text="上一页"
                    next-text="下一页"
                    @current-change="(val) => { handleCurrentChange(val, 1) }"
                    :current-page="sendBoxForm.pageNum"
                    :page-size="sendBoxForm.pageSize"
                    :total="sendBoxForm.tableDataTotal">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>

        <informationForm ref="infoForm" @refresh="()=>{refresh(typeName)}"></informationForm>
        <msgHistory ref="msgHistory"></msgHistory>
    </div>

</template>

<script>
import banner from '@/assets/imgs/banner_inviteMng.png'
import informationForm from './informationForm';
import msgHistory from './msgHistory';
import util from '@/util'

export default {
    name: 'msgex-mng-list',
    components: { informationForm, msgHistory },
    props: {
    },
    data () {
        return {
            typeName: '-1',
            statusList: [
                {
                    value: '-2',
                    label: '草稿'
                },
                {
                    value: '-1',
                    label: '已发送'
                }
            ],
            innerStatusList: [
                {
                    value: '0',
                    label: '未读'
                },
                {
                    value: '1',
                    label: '已读'
                }
            ],
            messageTypeList: [
                {
                    value: '0',
                    label: '合同'
                },
                {
                    value: '1',
                    label: '通知'
                },
                {
                    value: '2',
                    label: '维修'
                },
                {
                    value: '3',
                    label: '其他'
                }
            ],
            sendBoxForm: {
                stockId: this.$root.stockId,
                messageType: '',
                readFlag: '',
                type: 1,
                pageNum: 1,
                tableDataTotal: 0,
                readFlag: ''
            },
            sendBoxTableLoading: false,
            sendBoxes: [],

            inBoxForm: {
                stockId: this.$root.stockId,
                messageType: '',
                type: 2,
                pageNum: 1,
                tableDataTotal: 0,
                readFlag: ''
            },
            inBoxes: [],
            inBoxTableLoading: false,

            activeName: 'inBox',
            informationDialogVisible: false
        }
    },
     created () {
        this.$root.navs = [{name: '信息互通',path: '/newMsgList'}]
        this.$root.headImage.src = banner
        this.$root.isPublic = false;
    },
    mounted () {
        // dev test
        window.ji = this;

        // 获取列表
        this.getInBoxData();

    },
    watch: {
    },
    computed: {
    },
    methods: {
        refresh(typeName) {
            this.typeName = typeName;
            if (this.activeName == 'sendBox') {
                this.resetSendBoxForm();
            }else {
                this.resetInBoxForm();
            }
        },
        viewMsgHistory (row) {
            this.$refs['msgHistory'].show(row.id, this.activeName === 'sendBox' ? '1' : '2');
        },
        addMsg () {
            this.$refs['infoForm'].showMessageDialog();
        },
        edit (row) {
            this.$refs['infoForm'].showEidtMessageDialog(row);
        },
        del (row) {
            this.$confirm('确定要删除该消息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('rest/api/msg/deleteBaseMsg', {id: row.id }).then((res) => {
                    if (res.data.result) {
                        this.searchSendBox();
                        this.searchInBox();
                        this.$message({type: 'success', message: '操作成功'})
                    }
                })
            }).catch(() => {
            })
        },
        resetInBoxForm () {
            this.inBoxForm = {
                stockId: this.$root.stockId,
                type: 2,
                messageType: '',
                pageNum: 1,
                tableDataTotal: 0,
                readFlag: ''
            };
            this.getInBoxData();
        },
        searchInBox () {
            this.inBoxForm.pageNum = 1;
            this.getInBoxData();
        },
        handleCurrentChange (val, type) {
            if (type === 1) {
                this.sendBoxForm.pageNum = val;
                this.getSendBoxData();
            } else {
                this.inBoxForm.pageNum = val;
                this.getInBoxData();
            }
        },
        resetSendBoxForm () {
            this.sendBoxForm = {
                stockId: this.$root.stockId,
                type: 1,
                messageType: '',
                readFlag: '',
                pageNum: 1,
                tableDataTotal: 0,
                readFlag: ''
            };
            this.getSendBoxData();
        },
        searchSendBox () {
            this.sendBoxForm.pageNum = 1;
            this.getSendBoxData();
        },
        getSendBoxData () {
            this.sendBoxTableLoading = true;
            let param = JSON.parse(JSON.stringify(this.sendBoxForm));
            if (this.typeName == '-1') {
                param.messageType = this.sendBoxForm.messageType;
            } else {
                param.messageType = this.typeName;
            }

            delete param.tableDataTotal;
            this.$http.post('rest/api/msg/baseMsgList', param).then((res) => {
                this.sendBoxTableLoading = false;
                if (res.data.result) {
                    this.sendBoxes = res.data.value.list || [];
                    this.sendBoxForm.tableDataTotal = res.data.value.count || 0;
                } else {
                    this.$alert(res.data.message)
                }
            })
        },
        getInBoxData () {
            this.inBoxTableLoading = true;
            let param = JSON.parse(JSON.stringify(this.inBoxForm));
            if (this.typeName == '-1') {
                param.messageType = this.inBoxForm.messageType;
            }else {
                param.messageType = this.typeName;
            }

            delete param.tableDataTotal;
            this.$http.post('rest/api/msg/baseMsgList', param).then((res)=>{
                this.inBoxTableLoading = false;
                if (res.data.result) {
                    this.inBoxes = res.data.value.list || [];
                    this.inBoxForm.tableDataTotal = res.data.value.count || 0;
                } else {
                    this.$alert(res.data.message)
                }
            })
        }
    }
}
</script>

<style scoped lang="postcss">
@import '../../../../assets/common.css';

a {color:var(--cMain);}

ul {padding: 0;margin:0;}
ul li {list-style:none;}

.msgex-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}
.msgex-list {padding:20px 0 10px 48px;border-top:1px dashed #E4E5E4;}
.msgex-list .msgex-title-top .title {line-height:48px;}

.msgex-title-top .arrow {margin-right:4px;}
.msgex-title-top .arrow.big {margin-left:20px;}
.msgex-title-top .arrow.rotate {transform:rotate(180deg);}

.msgex-list-box .title {font-size:16px;cursor:pointer}
/*.msgex-list-box .title.big {margin-left:20px;}*/
.msgex-list-box .title.unread {font-weight:bold;}
.msgex-list-box .title.unread::before {content:'';position:relative;margin-right:8px;top:-2px;display:inline-block;width:8px;height:8px;border-radius:8px;background:var(--cMain);}
.msgex-list-box .date {float:right;color:#8c8c8c;}
.msgex-list-box .dept {max-width:1000px;color:#777;padding-left:40px;display:inline-block;line-height:28px;background:url() no-repeat center left;background-image:url('data:image/png;base64,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');}
.msgex-list-box .reply {float:right;color:#636363;padding-left:20px;display:inline-block;line-height:28px;background:url() no-repeat center left;background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAIAAAB/6NG4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE2NTg3NEMwMUQzMDExRTg4MUNERTA2OTA4NzA1ODgxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE2NTg3NEMxMUQzMDExRTg4MUNERTA2OTA4NzA1ODgxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTY1ODc0QkUxRDMwMTFFODgxQ0RFMDY5MDg3MDU4ODEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTY1ODc0QkYxRDMwMTFFODgxQ0RFMDY5MDg3MDU4ODEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz76O1RQAAACFElEQVR42iSRTUtVURSG37U/zjn33KvXD1LBTKGcFCiENikion5EBM37HVGBAwdCAwc5l2ZOgqIGDUJq0qiUsiZBZeZVr+ee/XH2Xm1wj9Z62ay1n2cTb6/23m8WR59j2TVUZP64ncsDF7rNCBWDypqhcqhfW9eZmrz2gPqrl8rbj8TcdXgPUCCSyKCd94pb1mG4c3KErPH7H4/frKjorJhcqrozefRRgAEZJAvSRA69AqPIzkGCmPPDX8IJg1i1AxRrC00gxAAiNGlFRwUECUSrYlCqUFlEVAgCCuggHRU0QmStuEHUgKAYIbzkwqdbkYUqdON590W9dpWqQ7JBb9wy2xsacvBp3azfEV5kHn2pBGHEDyxrqoans7ll6Fxk0k0uqO48QxTjF83MIgpD1PaFhHsyG35/scyWw4BdKhpmw8y+dnzKgZ3nOrU/d6unpTDxRMBnNlkyAjphyMAyMcr0vNikSCJHjMQWEwJZGSgbJEYqk8Q02EtS0TaUAIdS7MhR9KKTF/6vCC4n0culh99n0kq6Jonhdo3ghENIP5AxclOfNq2Sms37/X8/0B4jPd6+95zfrtD0kpy/Sztb/GGtJwoKcbRBZQ9aE1eSzBOzt9Oye274vJy5IXa3/rx8PDW3fPj99djNh1X3csZ18mv0bHFhARwT8OBMBcckI7hvr8yzxfD1XTLkU9hYjoMzUf8FGADOHjRSE/d3JQAAAABJRU5ErkJggg==");}
.msgex-list-box .title:hover,
.msgex-list-box .reply:hover {color:var(--cMain);}

    .red {
        color: red;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dsp/msgex/comps/newMsgexList.vue